import { Icon, useTheme, Typography } from '../../../base';
import { useTranslation } from 'react-i18next';
import {
    EmptyStateWrapper,
    InlineEmptyStateWrapper,
} from './EmptyState.styles';

interface Props {
    isInline?: boolean;
}

const EmptyState = ({ isInline = false }: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const content = (
        <>
            <Icon name="JobsIconBig" size={100} color="primary" />
            <Typography variant="h4">{t('jobsBoard.noJobsFound')}</Typography>
            <Typography variant="body1" sx={{ color: theme.palette.grey[600] }}>
                {t('jobsBoard.noJobsFoundDescription')}
            </Typography>
        </>
    );

    return isInline ? (
        <InlineEmptyStateWrapper>{content}</InlineEmptyStateWrapper>
    ) : (
        <EmptyStateWrapper>{content}</EmptyStateWrapper>
    );
};

export default EmptyState;
